export const QUERY_KEY = {
  CURRENT_USER: "current-user",
  CURRENT_USER_PERMISSIONS: "current-user-permissions",
  CURRENT_EDUCATOR: "current-educator",
  MAINTENANCE_SETTINGS: "maintenance-settings",
  PLATFORMS: "platforms",
  GET_ROLES: "get-roles",
  GET_ROLE: "get-role",
  GET_TAG: "get-tag",
  GET_TAGS: "get-tags",
  GET_NOTIFICATIONS: "get-notifications",
  GET_NOTIFICATION: "get-notification",
  GET_EDUCATOR_RESOURCE: "get-educator-resource",
  GET_EDUCATOR_RESOURCES: "get-educator-resources",
  GET_DEFAULT_SUBSCRIPTION_LIST: "get-default-subscription-list",
  GET_DEFAULT_SUBSCRIPTION: "get-default-subscription",
  GET_LANGUAGES: "get-languages",
  GET_LANGUAGE: "get-language",
  GET_USER: "get-user",
  GET_USERS: "get-users",
  GET_ADMIN_USERS: "get-admin-users",
  GET_ADMIN_ACTION_LOGS: "get-admin-action-logs",
  GET_USER_ACTION_LOGS: "get-user-action-logs",
  APP_CONTEXT_GET_ALL_EDUCATORS: "app-context-get-all-educators",
  APP_CONTEXT_GET_MARKETS: "app-context-get-markets",
  GET_TIMEZONES: "get-timezones",
  GET_TIMEZONE: "get-timezone",
  GET_EDUCATORS: "get-educators",
  GET_ALL_EDUCATORS: "get-all-educators",
  GET_EDUCATOR: "get-educator",
  GET_ZOOM: "get-zoom",
  GET_ZOOM_USER_LIST: "get-zoom-user-list",
  GET_ZOOM_EDUCATOR_LIST: "get-zoom-educator-list",
  GET_ZOOM_LIST: "get-zoom-list",
  ZOOM_INTERPRETATION_SETTING: "zoom-interpretation-setting",
  GET_MARKET: "get-market",
  GET_MARKETS: "get-markets",
  GET_USER_MARKET_ACCESS: "get-user-market-access",
  GET_CATEGORY: "get-category",
  GET_CATEGORIES: "get-categories",
  GET_SCHEDULES: "get-schedules",
  GET_SCHEDULE: "get-schedule",
  GET_SCHEDULE_CHANNELS: "get-schedule-channels",
  GET_ZOOM_AUTH_URL: "get-zoom-auth-url",
  GET_AVAILABLE_TIME_SLOTS: "get-available-time-slots",
  GET_CHANNELS: "get-channels",
  GET_CHANNEL: "get-channel",
  GET_PARTIAL_CHANNELS: "get-partial-channels",
  GET_CHANNEL_DELAYED_JOBS: "get-channel-delayed-jobs",
  GET_CHANNEL_FAQS: "get-channel-faqs",
  GET_CHANNEL_FAQ: "get-channel-faq",
  GET_LIVESTREAM_EVENT_RTMP_KEY: "get-livestream-event-rtmp-key",
  GET_S3_VIDEO_URL: "get-s3-video-url",
  GET_VIDEO: "get-video",
  GET_VIDEO_ANALYTICS: "get-video-analytics",
  GET_R2_TO_CLOUDFLARE_STATUS: "get-r2-to-cloudflare-status",
  GET_VIDEO_AUDIO_TRACKS: "get-video-audio-tracks",
  GET_PLAYLIST: "get-playlist",
  GET_ACADEMY_PLAYLIST: "get-academy-playlist",
  GET_VIDEOS: "get-videos",
  GET_PLAYLISTS: "get-playlists",
  GET_ACADEMY_PLAYLISTS: "get-academy-playlists",
  GET_AVAILABLE_TAGS_FOR_CHANNEL: "get-available-tags-for-channel",
  GET_SUBSCRIPTIONS: "get-subscriptions",
  GET_SUBSCRIPTION: "get-subscription",
  GET_S3_SIGNED_URL: "get-s3-signed-url",
  GET_S3_MULTIPART_UPLOAD_DATA: "get-s3-multipart-upload-data",
  GET_LIVESTREAM_URL: "get-livestream-url",
  GET_PATH: "get-path",
  GET_PATHS_LIST: "get-paths-list",
  GET_PATH_GROUPS: "get-path-groups",
  GET_POLICY: "get-policy",
  GET_ASSETS: "get-assets",
  GET_ASSET: "get-asset",
  GET_RESOURCE: "get-resource",
  GET_RESOURCES: "get-resources",
  RECOMMENDATION_SETTINGS: "recommendations-settings",
  GET_CMI5_PREVIEW: "get-cmi5-preview",
  GET_VIMEO_DOWNLOAD_URL: "get-vimeo-download-url",
  WES_LANDING_CONFIGS: "wes-landing-configs",
  WES_LANDING_CONFIG: "wes-landing-config",
};
